import {useContext} from 'react';

import {ToastProviderContext} from '#component/provider';

export function useToastQueue() {
  return useContext(ToastProviderContext);
}
